import { PenLine, Lock } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { useReviewWindow, closedOn, daysLeftText } from '../../hooks/useReviewWindow';

const CODE = {
  open: 'border-[#39FF14] text-[#39FF14] hover:bg-[#39FF14] hover:text-[#050003]',
  soon: 'border-[#FF9F0A] text-[#FF9F0A] hover:bg-[#FF9F0A] hover:text-[#050003]',
  off: 'border-[#2A0F3D] text-[#4B6B52] cursor-not-allowed',
  base: 'font-mono text-xs uppercase tracking-wider px-3 py-1.5',
};
const MODERN = {
  open: 'border-[#047857] text-[#047857] hover:bg-[#047857] hover:text-white',
  soon: 'border-[#D97706] text-[#B45309] hover:bg-[#D97706] hover:text-white',
  off: 'border-[#E7E5E0] text-[#A8A29E] bg-[#FBFAF7] cursor-not-allowed',
  base: 'text-xs font-semibold rounded-full px-3.5 py-1.5',
};

// "Post a review · 12 days left" / "🔒 Review window closed (Sep 12)" / "Buy & receive this to review it".
export function ReviewWindowButton({ productId, onOpen, modern = false }) {
  const { user } = useAuth();
  const isCustomer = user?.role === 'customer';
  const win = useReviewWindow([productId], isCustomer);
  const st = win?.items?.[productId];
  const k = modern ? MODERN : CODE;
  if (!isCustomer || !st) return null;

  let label; let tone; let disabled = false; let Icon = PenLine;
  if (!st.purchased) { label = 'Buy & receive this to review it'; tone = 'off'; disabled = true; Icon = Lock; }
  else if (!st.open) { label = `Review window closed (${closedOn(st.closes_at)})`; tone = 'off'; disabled = true; Icon = Lock; }
  else {
    const verb = st.reviewed ? 'Edit your review' : 'Post a review';
    label = st.days_left == null ? verb : `${verb} · ${daysLeftText(st.days_left)}`;
    tone = st.days_left != null && st.days_left <= 3 ? 'soon' : 'open';
  }
  return (
    <button type="button" disabled={disabled} onClick={disabled ? undefined : onOpen}
      className={`inline-flex items-center gap-1.5 border transition-colors ${k.base} ${k[tone]}`}
      data-testid="drawer-post-review-btn" data-state={disabled ? 'locked' : tone}>
      <Icon className="w-3 h-3" /> {label}
    </button>
  );
}
